exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-favorito .btn[data-v-7e6b554c] {\n  color: #fff;\n  width: 27px;\n  height: 27px;\n  padding: 0;\n  text-shadow: 1px 1px 2px #3333338c;\n}\n.btn-favorito .btn > .mdi[data-v-7e6b554c] {\n  width: 25px;\n  height: 25px;\n  font-size: 25px;\n  text-align: center;\n  line-height: 25px;\n  margin-left: auto;\n}\n.btn-favorito .btn > .mdi.stay[data-v-7e6b554c] {\n  display: block;\n}\n.btn-favorito .btn > .mdi.hover[data-v-7e6b554c] {\n  display: none;\n}\n.btn-favorito .btn:hover > .mdi.stay[data-v-7e6b554c] {\n  display: none;\n}\n.btn-favorito .btn:hover > .mdi.hover[data-v-7e6b554c] {\n  display: block;\n}", ""]);

// exports
